const pendants = [
  {
    id: "pendant-001",
    name: "Blue Topaz Double Hook Pendant",
    price: 23000,
    preorder: true,
    description: "Blue Mirage — a striking double hook pendant featuring a luminous blue topaz.",
    gem: "Topaz",
    src: "/pendants/RGP-004.webp",
    details: { gemstone: "Blue Topaz", carat: "Approx. 2.27 ct", metal: "Sterling Silver (925)", size: "9mm x 7mm", origin: "Sri Lanka", certification: "Certified Authenticity" }
  },
  {
    id: "pendant-005",
    name: "Citrine Teardrop Pendant",
    price: 22500,
    preorder: true,
    deal: true,
    originalPrice: 25500,
    description: "Morning Dew - This beautiful handmade pendant features a light pear shaped Citrine, set in a simple, timeless design that lets its soft golden glow shine effortlessly",
    gem: "Citrine",
    src: "/pendants/RGP-001.webp",
    details: { gemstone: "Citrine", carat: "4.30 ct", metal: "Sterling Silver (925)", size: "12.5mm x 9mm", origin: "Sri Lanka", certification: "Full gem report included" }
  },
  {
    id: "pendant-016",
    name: "London Blue Topaz Solitaire Pendant",
    price: 34000,
    preorder: true,
    description: "Midnight Glow - Featuring a stunning round cut London Blue Topaz, this handcrafted pendant is elegantly set in luxurious 18kt Gold Plated Sterling Silver (925), creating a timeless design that beautifully showcases its rich midnight blue brilliance.",
    gem: "Topaz",
    src: "/pendants/RGP-018.webp",
    details: {
      gemstone: "London Blue Topaz",
      carat: "4.50 ct(approx)",
      metal: "18kt Gold Plated Sterling Silver (925)",
      size: "Approx. 9mm Round",
      origin: "Sri Lanka",
      certification: "Full gem report included"
    }
  },
  {
    id: "pendant-017",
    name: "Red Garnet Solitaire Pendant",
    price: 44000,
    preorder: true,
    description: "Crimson Flame - Showcasing a beautiful round cut Red Garnet, this handcrafted pendant is beautifully set in luxurious 18kt Gold Plated Sterling Silver (925). Its timeless solitaire design highlights the gemstone's deep crimson sparkle, creating a bold yet elegant piece for every occasion.",
    gem: "Garnet",
    src: "/pendants/RGP-017.webp",
    details: {
      gemstone: "Red Garnet",
      carat: "5.00 ct (approx)",
      metal: "18kt Gold Plated Sterling Silver (925)",
      size: "Approx. 9mm Round",
      origin: "Sri Lanka",
      certification: "Full gem report included"
    }
  },
  {
    id: "pendant-012",
    name: "Pearl & Garnet Pendant",
    price: 17500,
    deal: true,
    originalPrice: 22498,
    description: "Timeless Grace — a lustrous pearl paired with a deep almandine garnet in a classic silver setting.",
    gem: "Pearl",
    src: "/pendants/RGP-012.webp",
    details: { gemstone: "Pearl & Garnet", carat: "—", metal: "Sterling Silver (925)", size: "22mm x 12mm", origin: "Sri Lanka", certification: "Certified Authenticity" }
  },
  {
    id: "pendant-010",
    name: "London Blue Swirl Pendant",
    price: 38500,
    preorder: true,
    description: "Deep Ocean — a rich London blue topaz cradled in an elegant silver swirl.",
    gem: "Topaz",
    src: "/pendants/RGP-010.webp",
    details: { gemstone: "London Blue Topaz", carat: "Approx. 9.50 ct", metal: "Sterling Silver (925)", size: "18 × 13 mm", origin: "Sri Lanka", certification: "Certified Authenticity" }
  },
  {
    id: "pendant-002",
    name: "Blue Topaz Bar Pendant",
    price: 29000,
    preorder: true,
    description: "Modern Horizon — a sleek silver bar pendant with a vivid blue topaz accent at the base.",
    gem: "Topaz",
    src: "/pendants/RGP-002.webp",
    details: { gemstone: "Blue Topaz", carat: "1.10 ct (approx)", metal: "Sterling Silver (925)", size: "4mm x 4mm", origin: "Sri Lanka", certification: "Certified Authenticity" }
  },
  {
    id: "pendant-003",
    name: "Blue Topaz Single Hook Pendant",
    price: 19500,
    preorder: true,
    description: "Santa Maria Elegance — a brilliant blue topaz in a minimalist single hook setting.",
    gem: "Topaz",
    src: "/pendants/RGP-014.webp",
    details: { gemstone: "Blue Topaz", carat: "Approx. 2.27 ct", metal: "Sterling Silver (925)", size: "9mm x 7mm", origin: "Sri Lanka", certification: "Certified Authenticity" }
  },
  {
    id: "pendant-004",
    name: "Citrine Swirl Pendant",
    price: 27000,
    preorder: true,
    description: "Amber Dawn — a golden citrine wrapped in a graceful swirl silver frame.",
    gem: "Citrine",
    src: "/pendants/RGP-005.webp",
    details: { gemstone: "Citrine", carat: "1.50 ct", metal: "Sterling Silver (925)", size: "18mm x 14mm", origin: "Sri Lanka", certification: "Certified Authenticity" }
  },
  {
    id: "pendant-006",
    name: "Garnet Butterfly Pendant",
    price: 25000,
    preorder: true,
    description: "Wings of Crimson — a deep almandine garnet set at the heart of a graceful butterfly motif.",
    gem: "Garnet",
    src: "/pendants/RGP-006.webp",
    details: { gemstone: "Almandine Garnet", carat: "1.20 ct", metal: "Sterling Silver (925)", size: "22mm x 20mm", origin: "Sri Lanka", certification: "Certified Authenticity" }
  },
  {
    id: "pendant-007",
    name: "Garnet Double Hook Pendant",
    price: 25500,
    preorder: true,
    description: "A Touch of Deep Romance — rich almandine garnet in a double hook silver pendant.",
    gem: "Garnet",
    src: "/pendants/RGP-008.webp",
    details: { gemstone: "Almandine Garnet", carat: "Approx. 2.10 ct", metal: "Sterling Silver (925)", size: "9mm x 7mm", origin: "Sri Lanka", certification: "Certified Authenticity" }
  },
  {
    id: "pendant-008",
    name: "Garnet single hook Pendant",
    price: 19500,
    preorder: true,
    description: "Classic Crimson — a timeless garnet pendant with understated elegance.",
    gem: "Garnet",
    src: "/pendants/RGP-007.webp",
    details: { gemstone: "Almandine Garnet", carat: "Approx. 2.10 ct", metal: "Sterling Silver (925)", size: "9mm x 7mm", origin: "Sri Lanka", certification: "Certified Authenticity" }
  },
  {
    id: "pendant-009",
    name: "Infinity Garnet Pendant",
    price: 32000,
    preorder: true,
    description: "Eternal Flame — a rich garnet set within an infinity-inspired silver design.",
    gem: "Garnet",
    src: "/pendants/RGP-009.webp",
    details: { gemstone: "Almandine Garnet", carat: "Approx. 2.10 ct", metal: "Sterling Silver (925)", size: "9mm x 7mm", origin: "Sri Lanka", certification: "Certified Authenticity" }
  },
  {
    id: "pendant-011",
    name: "Peridot Pendant",
    price: 22000,
    preorder: true,
    description: "Fresh Bloom — a vivid green peridot radiating natural vitality in silver.",
    gem: "Peridot",
    src: "/pendants/RGP-011.webp",
    details: { gemstone: "Peridot", carat: "Approx. 2.00 ct", metal: "Sterling Silver (925)", size: "9mm x 7mm", origin: "Sri Lanka", certification: "Certified Authenticity" }
  },
  {
    id: "pendant-013",
    name: "Pink Tourmaline Swirl Pendant",
    price: 35000,
    preorder: true,
    description: "Blush Whisper — a soft pink tourmaline embraced by an elegant silver swirl.",
    gem: "Tourmaline",
    src: "/pendants/RGP-013.webp",
    details: { gemstone: "Pink Tourmaline", carat: "1.60 ct", metal: "Sterling Silver (925)", size: "20mm x 14mm", origin: "Sri Lanka", certification: "Certified Authenticity" }
  },
  {
    id: "pendant-014",
    name: "Pink Tourmaline E Swirl Pendant",
    price: 35500,
    preorder: true,
    description: "Rose Spiral — a vibrant pink tourmaline in a statement swirl silver setting.",
    gem: "Tourmaline",
    src: "/pendants/RGP-003.webp",
    details: { gemstone: "Pink Tourmaline", carat: "1.75 ct", metal: "Sterling Silver (925)", size: "22mm x 16mm", origin: "Sri Lanka", certification: "Certified Authenticity" }
  },
  {
    id: "pendant-015",
    name: "Swiss Blue Square Pendant",
    price: 25000,
    preorder: true,
    description: "Sky Serenade — a vivid Swiss blue topaz in a clean square silver setting.",
    gem: "Topaz",
    src: "/pendants/RGP-015.webp",
    details: { gemstone: "Swiss Blue Topaz", carat: "1.35 ct", metal: "Sterling Silver (925)", size: "14mm x 14mm", origin: "Sri Lanka", certification: "Certified Authenticity" }
  },
  {
    id: "pendant----pearl-harmony-3507",
    name: "Pearl Harmony",
    price: 18500,
    deal: true,
    originalPrice: 25000,
    description: "A beautiful blend of pearls, peridot, Blue Topaz, and citrine, coming together in perfect balance inspired by nature’s most radiant colours.",
    gem: "Pearl",
    src: "/pendants/RGP-016.webp",
    details: { gemstone: "Pearl,Citrine,peridot,topaz", carat: "15ct (approx) ", metal: "Sterling Silver (925)", size: "", origin: "Sri Lanka", certification: "Certified Authenticity" }
  }
];

export default pendants;